module.exports = __webpack_public_path__ + "static/media/denim.5315239a.svg";